module.exports = __webpack_public_path__ + "static/tiffany-01-2ed1ab851faeedf746d7b572b8081666.jpg";